import { reactive } from 'vue';
import DinastiaWhatsappChannel from '../api/channel/dinastiaWhatsappChannel';

// Avatares de participante de grupo como ARQUIVO ESTATICO (nginx).
// Componentes pedem a URL por jid; os pedidos de uma mesma tela sao
// agrupados num unico POST avatar_manifest (debounce). Estados no cache:
//   string  -> URL estatica pronta (nginx, zero Puma)
//   null    -> participante sem foto (render sem <img>)
//   false   -> ainda materializando (caller usa o endpoint antigo)
//   undefined -> nunca pedido (agenda no lote)
const cache = reactive({});
const pendingByInbox = new Map();
let flushTimer = null;

const keyFor = (inboxId, jid) => `${inboxId}:${jid}`;

const flush = () => {
  flushTimer = null;
  pendingByInbox.forEach((jids, inboxId) => {
    const list = Array.from(jids);
    if (!list.length) return;
    DinastiaWhatsappChannel.avatarManifest(inboxId, list)
      .then(({ data }) => {
        const avatars = data?.avatars || {};
        list.forEach(jid => {
          cache[keyFor(inboxId, jid)] = avatars[jid];
        });
      })
      .catch(() => {
        // Falhou o lote: libera pra re-tentar num proximo render
        list.forEach(jid => {
          delete cache[keyFor(inboxId, jid)];
        });
      });
  });
  pendingByInbox.clear();
};

const schedule = (inboxId, jid) => {
  if (!pendingByInbox.has(inboxId)) pendingByInbox.set(inboxId, new Set());
  pendingByInbox.get(inboxId).add(jid);
  if (!flushTimer) flushTimer = setTimeout(flush, 60);
};

/**
 * URL do avatar do participante. Retorna a estatica quando materializada;
 * `fallbackUrl` enquanto o arquivo ainda nao existe; '' quando o
 * participante nao tem foto.
 */
export function participantAvatarUrl(inboxId, jid, fallbackUrl) {
  if (!inboxId || !jid) return '';
  const key = keyFor(inboxId, jid);
  const value = cache[key];
  if (typeof value === 'string') return value;
  if (value === null) return '';
  if (value === undefined) {
    cache[key] = false; // marca como pedido (evita re-agendar a cada render)
    schedule(inboxId, jid);
  }
  return fallbackUrl || '';
}
